/**
 * @file 创建 Application 实例
 * @author svon.me@gmail.com
 */

import { createApp as create } from 'vue';

const Router = () => import("../router");
const Application = () => import("./app.vue");

export const createApp = async function () {
  const [ view, router ] = await Promise.all([
    Application(),
    Router()
  ]);
  const app = create(view.default ? view.default : view, {
    // compilerOptions: {
    //     isCustomElement: tag => [ 'Borad','FullScreen','Tickets','vue-picture-swipe'].includes(tag)
    // }
  });
  return { 
    app, 
    router: router.default ? router.default : router
  };
}